
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skiudlejning",
      function () {
        return require("private-next-pages/[region]/[resort]/skiudlejning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skiudlejning"])
      });
    }
  